import {
    redirectToCommericalTrial,
    redirectToContractSales,
    redirectToPlan,
    redirectToPurchasePayment,
    redirectToPurchasePeriodPaymentPayment,
} from 'businessCommon/src/services';
import { _lang, lang, commonLang, dupLang, getCurrentLang, getCurrentSystem, isSystem, isLang } from '@umu/ukit-lang';
import React, { useCallback, Fragment, useState } from 'react';
import dayjs from 'dayjs';

import { IEditionItem, IPlanInfo, PLAN_TYPE, VERSION_TYPE, IUserInfo } from '@umu/umu-types';
import { Toast } from 'common/src/services';
import { handlePromiseError } from 'common/utils/errorHandler';
import { PreImg, Button, If, Dialog, DialogBody, DialogHeader, CustomDialog } from 'common/src/components';
import { DialogTips } from '../dialogTips/dialogTips';
import { getUnitPrice } from './dataFlow';

import { ProFessionalCO } from './coVersionItem/proFessionalCO';
import { CommericalCo } from './coVersionItem/commericalCo';
import { ACTION_TYPE, DEVICE_FROM_MAP } from '@umu/umu-api/src/services/payment/paymentEvent';
import {
    basicEdition,
    professionalEdition,
    businessEdition,
    enterpriseEdition,
    trackEvent,
    eduProfessionalEdition,
} from '../../utils/util';
import { DistinctionCO } from '../distinctionCO';
import { getAppData } from '../../service/planPricingService';
import { setStatLogDialogs } from '@umu/umu-api';
import { useSurfacePricing } from '../../hooks/useSurfacePricing';
import { DiscountTag } from '../discountTag/discountTag';
import { BasicBuyButton, EnterpriseBuyButton, ProfessionalBuyButton } from '../buyButton';
import { HideInApp, ShowInApp } from '../hideInApp';
import { ISurfacePricing } from '@umu/umu-api';
import { applyAppPurchase } from 'plan/@planPricingCommon/utils/util';
import { isInApp } from '@umu/umu-ua';
import './versionItem.scss';
import { setSwitchVersion } from 'plan/@planPricingCommon/service/switchVersion';
import { $window } from '@umu/umu-dom';

const isApp = isInApp();
const isCO = isSystem('JP');
const system = getCurrentSystem();
const localeLang = getCurrentLang();

const closeImg = require(`../../images/close.png`);
const openImg = require(`../../images/open.png`);

interface IVersionItemProps {
    isRegisterUser: boolean;
    planInfo: IPlanInfo;
    siteHost: string;
    userInfo?: IUserInfo;
    platform: 'twww' | 'mobile';
}
const onSwitchVersion = async () => {
    setSwitchVersion('9')
        .then((errorCode: string) => {
            if (!Number(errorCode)) {
                Toast.show(commonLang('完成版本切换，请重新登录'));
                $window.location.href = '/globaluser/loginpage';
            }
            if (Number(errorCode) === 20001) {
                CustomDialog({
                    className: 'switch-version-dialog-tips',
                    canClose: true,
                    width: '4rem',
                    childProps: {
                        title: commonLang('无法切换团队版'),
                        descList: [commonLang('提交数据有误')],
                        isShowCancel: false,
                        submitText: commonLang('知道了'),
                    },
                    contentComponent: DialogTips,
                });
            } else if (Number(errorCode) === 20305) {
                CustomDialog({
                    className: 'switch-version-dialog-tips',
                    canClose: true,
                    width: '4rem',
                    childProps: {
                        title: commonLang('无法切换团队版'),
                        descList: [commonLang('切换版本频率太高，请稍后再试。')],
                        isShowCancel: false,
                        submitText: commonLang('知道了'),
                    },
                    contentComponent: DialogTips,
                });
            }
        })
        .catch((error: unknown) => {
            handlePromiseError(error, 'VersionItem.onSwitchVersion', 'VersionItem setSwitchVersion error', {
                versionType: '9',
            });
        });
};
const onSwitchProfessionalVersion = (planInfo: IPlanInfo) => {
    const { expire_time } = planInfo;
    const expireTimeLabel = dayjs(expire_time * 1000).format('YYYY-MM-DD HH:mm:ss');
    CustomDialog({
        className: 'switch-version-dialog-tips',
        canClose: true,
        width: '4rem',
        childProps: {
            title: commonLang('确认切换团队版？'),
            descList: [
                commonLang('当前正在使用专业版，到期时间为${expireTime}，请确认是否切换为团队版？').replace(
                    '${expireTime}',
                    expireTimeLabel,
                ),
                commonLang(
                    '切换为团队版后将包含10个席位，学习平台仅限内部席位账号访问，更加安全合规；团队版到期时间为${expireTime}。',
                ).replace('${expireTime}', expireTimeLabel),
            ],

            isShowCancel: true,
            onSubmitClick: onSwitchVersion,
            submitText: commonLang('切换'),
        },
        contentComponent: DialogTips,
    });
};
export const VersionItem = (props: IVersionItemProps) => {
    const { isRegisterUser, planInfo, siteHost, platform, userInfo } = props;
    const [isShowBasic, setShowBasic] = useState(platform === 'twww');
    const [isShowProFessional, setShowProFessional] = useState(platform === 'twww');
    const [isShowCommerical, setShowCommerical] = useState(true);
    const [isShowEnterprise, setShowEnterprise] = useState(platform === 'twww');
    const businessEditionList = platform === 'twww' && !isSystem('JP') ? businessEdition.slice(0, -1) : businessEdition;
    const enterpriseEditionList = enterpriseEdition;
    const professionalEditionList = professionalEdition;
    const isEduProfessional = isRegisterUser && planInfo.teacher_status === 6;
    const surfacePricing = useSurfacePricing();
    const professionalPricing = surfacePricing ? surfacePricing[2] : undefined;
    const teamPricing = surfacePricing ? surfacePricing[3] : undefined;

    const getPremiumPrice = () => {
        if (!professionalPricing) {
            return '';
        }
        return professionalPricing.amount_settle || professionalPricing.amount;
    };
    const getBusinessPrice = () => {
        if (!teamPricing) {
            return '';
        }
        return teamPricing.amount_settle || teamPricing.amount;
    };

    const getList = (list: IEditionItem[]) => {
        const ret: JSX.Element[] = [];
        list.map((item: IEditionItem, index: number) => {
            if (!item.hide) {
                ret.push(
                    <div key={index} className="contant-item clearfix">
                        <div
                            className={
                                item.isCheckMark === 1
                                    ? 'contant-item-mark contant-item-bg'
                                    : 'contant-item-mark contant-item-bg1'
                            }
                        >
                            {item.isCheckMark === 1 ? '' : '＊'}
                        </div>
                        <div className="contant-item-text">{item.des}</div>
                    </div>,
                );
            }
        });
        return ret;
    };

    const [unitPrice, unitPriceDes] = getUnitPrice();

    const onPlan = useCallback(
        (planId: number, isBuyNow?: boolean) => {
            if (applyAppPurchase(planId)) {
                return;
            }
            redirectToPlan(platform, isRegisterUser, planId, isBuyNow);
        },
        [siteHost, isRegisterUser, platform],
    );

    const redirectInCommerical = () => {
        // 团队版试用
        if (planInfo.teacher_status === VERSION_TYPE.COMMERICAL_TRIAL) {
            redirectToPurchasePayment(platform, PLAN_TYPE.COMMERICAL);
            return;
        }
        redirectToPurchasePeriodPaymentPayment(platform);
        return;
    };

    // 标记申请商用试用版，用于控制展示欢迎弹窗
    const markStartCommercialTrial = () => {
        const userInfo = getAppData('userInfo');
        const isStartTrial = `IS_START_TRIAL_${userInfo.teacher_id}_${userInfo.umu_id}`;
        localStorage.setItem(isStartTrial, '1');
    };

    const shouldDisplayTeamVersionButton = (): boolean => {
        if (isApp) {
            return true;
        }

        if (!isApp && !isRegisterUser) {
            // 显示 "免费试用" 和 "立即购买" 按钮
            return true;
        }

        if (!isApp && isRegisterUser && planInfo.plan_id < 3) {
            // 显示 "立即购买" 按钮和切换按钮
            return true;
        }

        if (!isApp && isRegisterUser && planInfo.plan_id === 3) {
            if (planInfo.teacher_status === VERSION_TYPE.COMMERICAL) {
                // 显示 "正在使用" 按钮
                return true;
            }

            if (planInfo.teacher_status === VERSION_TYPE.COMMERICAL_TRIAL) {
                // 显示 "立即购买" 按钮
                return true;
            }
        }

        // 在其他情况下，不显示按钮
        return false;
    };

    const renderDiscountTag = (data?: ISurfacePricing) => {
        if (!data) {
            return null;
        }
        return <DiscountTag {...data} />;
    };

    const renderSwitchButton = () => {
        const isCn = isSystem('CN');
        const isProfessional = Number(planInfo.teacher_status) === 2;
        const isExpire = Number(planInfo.expire_days) === 0;
        const isShow = isCn && isProfessional && !isExpire;

        if (isShow) {
            return (
                <Button
                    className="switch-version-btn"
                    alias="text"
                    type="blue-border"
                    onClick={() => onSwitchProfessionalVersion(planInfo)}
                >
                    {commonLang('切换团队版')}
                </Button>
            );
        }
        if (planInfo.business_free_trial === 1) {
            return (
                <div>
                    <span className="price-edition-texts">{lang('或')}&nbsp;</span>
                    <Button
                        className="price-edition-text"
                        alias="text"
                        onClick={() => {
                            trackEvent(ACTION_TYPE.CLICK_FREE, DEVICE_FROM_MAP[platform]);
                            markStartCommercialTrial();
                            redirectToCommericalTrial(platform, isRegisterUser);
                        }}
                    >
                        {commonLang('免费试用')}
                    </Button>
                </div>
            );
        }
        return null;
    };

    // 默认是 en，这样符合大多数语言
    let recommendBackgroundImageCls = 'recommend-en';
    if (isLang('cn')) {
        recommendBackgroundImageCls = 'recommend-cn';
    } else if (isLang('jp')) {
        recommendBackgroundImageCls = 'recommend-jp';
    } else if (isLang('ko')) {
        recommendBackgroundImageCls = 'recommend-ko';
    } else if (isLang('tw')) {
        recommendBackgroundImageCls = 'recommend-tw';
    }

    return (
        <Fragment>
            <Fragment>
                <If condition={isShowBasic}>
                    <div className={platform === 'twww' ? 'version-item' : 'version-item version-m-item'}>
                        <div className="version-item-title">
                            {lang('基本版')}
                            <If condition={platform === 'mobile'}>
                                <div
                                    className="close-wraper"
                                    onClick={() => {
                                        setShowBasic(false);
                                    }}
                                >
                                    <PreImg>
                                        <img className="close-version" src={closeImg} alt="" />
                                    </PreImg>
                                </div>
                            </If>
                        </div>
                        <div className="version-item-des">{lang('适用于个人用户')}</div>
                        <div className="version-item-price">
                            <div className="price-des price-des-text">
                                <div className="price-basic-text">
                                    <div className="price-enterprise-text">{lang('免费')}</div>
                                </div>
                            </div>
                            <BasicBuyButton className="price-button-m" {...props} />
                        </div>
                        <div className="version-item-content">
                            <div className="content-title">
                                {isCO ? lang('以下の無料機能を提供：') : lang('简单易用的互动教学工具：')}
                            </div>
                            <div className="content-list">{getList(basicEdition)}</div>
                        </div>
                    </div>
                </If>
                <If condition={!isShowBasic && !isRegisterUser}>
                    <div
                        className="version-item-tab"
                        onClick={() => {
                            setShowBasic(true);
                        }}
                    >
                        <div className="version-tab-title">{lang('基本版')} </div>
                        <PreImg>
                            <img className="open-version" src={openImg} alt="" />
                        </PreImg>
                    </div>
                </If>
            </Fragment>
            <Fragment>
                <If condition={isShowProFessional}>
                    <DistinctionCO>
                        <ProFessionalCO
                            {...{
                                ...props,
                                setShowProFessional,
                                getList,
                                professionalPricing: professionalPricing || undefined,
                            }}
                        />

                        <div className={platform === 'twww' ? 'version-item' : 'version-item version-m-item'}>
                            <div className="version-item-title">
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: dupLang(
                                            '专业版',
                                            'src/plan/@planPricingCommon/components/@pricingVersion',
                                        ),
                                    }}
                                ></span>
                                <If condition={platform === 'mobile'}>
                                    <div
                                        className="close-wraper"
                                        onClick={() => {
                                            setShowProFessional(false);
                                        }}
                                    >
                                        <PreImg>
                                            <img className="close-version" src={closeImg} alt="" />
                                        </PreImg>
                                    </div>
                                </If>
                            </div>
                            <div className="version-item-des des-top">{lang('适用于个人培训师')}</div>
                            <div className="version-item-price">
                                <HideInApp>
                                    <div className="price-des">
                                        <div className="unit-price-wrapper">
                                            <If condition={system === 'CN'}>
                                                <Fragment>
                                                    <div className="unit-price-text">￥</div>
                                                    <div className="unit-price-number">
                                                        {getPremiumPrice()}
                                                        <span className="time-unit"> / {lang('年_v2')}</span>
                                                    </div>
                                                </Fragment>
                                            </If>
                                            <If condition={system === 'EN'}>
                                                <Fragment>
                                                    <div className="unit-price-text">$</div>
                                                    <div className="unit-price-number">{getPremiumPrice()}</div>
                                                </Fragment>
                                            </If>
                                            <If condition={system === 'EM'}>
                                                <Fragment>
                                                    <div className="unit-price-text">$</div>
                                                    <div className="unit-price-number">{getPremiumPrice()}</div>
                                                </Fragment>
                                            </If>
                                            <If condition={system === 'TW'}>
                                                <Fragment>
                                                    <div className="unit-price-text">NT$</div>
                                                    <div className="unit-price-number">{getPremiumPrice()}</div>
                                                </Fragment>
                                            </If>
                                        </div>
                                        <If condition={system === 'CN'}>
                                            <>{renderDiscountTag(professionalPricing)}</>
                                        </If>
                                        <If
                                            condition={
                                                system !== 'CN' ||
                                                !!(professionalPricing && professionalPricing.discount === 1)
                                            }
                                        >
                                            <div className="unit-price-des">{unitPriceDes}</div>
                                        </If>
                                    </div>
                                </HideInApp>
                                <ProfessionalBuyButton {...props} userInfo={userInfo} />
                            </div>
                            <div className="version-item-content">
                                <div className="content-title">
                                    {isCO
                                        ? lang('ベーシックプランに加えて以下プレミア機能をサポート：')
                                        : lang('专业培训工具：')}
                                </div>
                                <div className="content-list">{getList(professionalEditionList)}</div>
                            </div>
                        </div>
                    </DistinctionCO>
                </If>
                <If condition={!isShowProFessional}>
                    <div
                        className="version-item-tab"
                        onClick={() => {
                            setShowProFessional(true);
                        }}
                    >
                        <div
                            className="version-tab-title"
                            dangerouslySetInnerHTML={{
                                __html: dupLang('专业版', 'src/plan/@planPricingCommon/components/@pricingVersion'),
                            }}
                        ></div>
                        <PreImg>
                            <img className="open-version" src={openImg} alt="" />
                        </PreImg>
                    </div>
                </If>
            </Fragment>
            <Fragment>
                <If condition={isShowCommerical}>
                    <DistinctionCO>
                        <CommericalCo
                            {...{
                                ...props,
                                teamPricing,
                                onPlan,
                                setShowCommerical,
                                redirectInCommerical,
                                markStartCommercialTrial,
                                getList,
                            }}
                        />

                        <div
                            className={
                                platform === 'twww' ? 'version-item shop-version' : 'version-item version-m-item'
                            }
                        >
                            <div className={`recommend ${recommendBackgroundImageCls}`}></div>
                            <div className="version-item-title">
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: dupLang(
                                            '团队版',
                                            'src/plan/@planPricingCommon/components/@pricingVersion',
                                        ),
                                    }}
                                ></span>
                                <If condition={platform === 'mobile'}>
                                    <div
                                        className="close-wraper"
                                        onClick={() => {
                                            setShowCommerical(false);
                                        }}
                                    >
                                        <PreImg>
                                            <img className="close-version" src={closeImg} alt="" />
                                        </PreImg>
                                    </div>
                                </If>
                            </div>
                            <div className="version-item-des">{lang('为团队学员购买账户')}</div>
                            <div className="version-item-price">
                                <HideInApp>
                                    <div className="price-des">
                                        <div className="unit-price-wrapper">
                                            <If condition={system === 'CN'}>
                                                <Fragment>
                                                    <div className="unit-price-text">￥</div>
                                                    <div className="unit-price-number">
                                                        {getBusinessPrice()}
                                                        <span className="time-unit"> / {lang('年_v2')}</span>
                                                    </div>
                                                </Fragment>
                                            </If>
                                            <If condition={system === 'EN'}>
                                                <Fragment>
                                                    <div className="unit-price-text">$</div>
                                                    <div className="unit-price-number">{getBusinessPrice()}</div>
                                                </Fragment>
                                            </If>
                                            <If condition={system === 'EM'}>
                                                <Fragment>
                                                    <div className="unit-price-text">$</div>
                                                    <div className="unit-price-number">{getBusinessPrice()}</div>
                                                </Fragment>
                                            </If>
                                            <If condition={system === 'TW'}>
                                                <Fragment>
                                                    <div className="unit-price-text">NT$</div>
                                                    <div className="unit-price-number">{getBusinessPrice()}</div>
                                                </Fragment>
                                            </If>
                                            <If condition={system === 'JP'}>
                                                <Fragment>
                                                    <div className="unit-price-number">{getBusinessPrice()}</div>
                                                    <div className="unit-price-text">円</div>
                                                </Fragment>
                                            </If>
                                        </div>
                                        <If condition={system === 'JP' && localeLang === 'jp'}>
                                            <div className="jp-des">（税込）/登録アカウント</div>
                                        </If>
                                        <If condition={system === 'JP' && localeLang === 'en'}>
                                            <div className="jp-des">（tax included）/account</div>
                                        </If>
                                        <div className="unit-price-des">{unitPrice}</div>
                                    </div>
                                </HideInApp>
                                {shouldDisplayTeamVersionButton() && (
                                    <div className="price-button">
                                        {/* todo 使用中情况 */}
                                        <ShowInApp>
                                            <Button
                                                className="price-edition-btn"
                                                alias="striking"
                                                onClick={() => {
                                                    setStatLogDialogs({ page_type: 16, action_type: '3' });
                                                    trackEvent(ACTION_TYPE.CLICK_CONTRACT, DEVICE_FROM_MAP[platform]);
                                                    redirectToContractSales(platform);
                                                }}
                                            >
                                                {commonLang('联系销售')}
                                            </Button>
                                        </ShowInApp>
                                        <If condition={!isApp && !isRegisterUser}>
                                            <>
                                                <Button
                                                    className="price-edition-btn now-buy-btn"
                                                    alias="striking"
                                                    onClick={() => {
                                                        trackEvent(ACTION_TYPE.CLICK_FREE, DEVICE_FROM_MAP[platform]);
                                                        redirectToCommericalTrial(platform, isRegisterUser);
                                                    }}
                                                >
                                                    {commonLang('免费试用')}
                                                </Button>
                                                <div>
                                                    <span className="price-edition-texts">{lang('或')}&nbsp;</span>
                                                    <Button
                                                        className="price-edition-text"
                                                        alias="text"
                                                        onClick={() => {
                                                            trackEvent(
                                                                ACTION_TYPE.CLICK_BUSINESS,
                                                                DEVICE_FROM_MAP[platform],
                                                            );
                                                            onPlan(PLAN_TYPE.COMMERICAL, true);
                                                        }}
                                                    >
                                                        {commonLang('立即购买')}
                                                    </Button>
                                                </div>
                                            </>
                                        </If>
                                        <If condition={!isApp && isRegisterUser && planInfo.plan_id < 3}>
                                            <Fragment>
                                                <Button
                                                    className="price-edition-btn now-buy-btn"
                                                    alias="striking"
                                                    onClick={() => {
                                                        trackEvent(
                                                            ACTION_TYPE.CLICK_BUSINESS,
                                                            DEVICE_FROM_MAP[platform],
                                                        );
                                                        onPlan(PLAN_TYPE.COMMERICAL, true);
                                                    }}
                                                >
                                                    {commonLang('立即购买')}
                                                </Button>
                                                {renderSwitchButton()}
                                            </Fragment>
                                        </If>

                                        <If
                                            condition={
                                                !isApp &&
                                                // tslint:disable-next-line:max-line-length
                                                isRegisterUser &&
                                                planInfo.plan_id === 3 &&
                                                planInfo.teacher_status === VERSION_TYPE.COMMERICAL
                                            }
                                        >
                                            <Fragment>
                                                <Button
                                                    className="price-edition-btn"
                                                    alias="striking"
                                                    onClick={redirectInCommerical}
                                                >
                                                    {commonLang('正在使用')}
                                                </Button>
                                            </Fragment>
                                        </If>
                                        <If
                                            condition={
                                                !isApp &&
                                                // tslint:disable-next-line:max-line-length
                                                isRegisterUser &&
                                                planInfo.plan_id === 3 &&
                                                planInfo.teacher_status === VERSION_TYPE.COMMERICAL_TRIAL
                                            }
                                        >
                                            <Button
                                                className="price-edition-btn now-buy-btn"
                                                alias="striking"
                                                onClick={() => {
                                                    trackEvent(ACTION_TYPE.CLICK_BUSINESS, DEVICE_FROM_MAP[platform]);
                                                    onPlan(PLAN_TYPE.COMMERICAL, true);
                                                }}
                                            >
                                                {commonLang('立即购买')}
                                            </Button>
                                        </If>
                                    </div>
                                )}
                            </div>
                            <div className="version-item-content">
                                <div className="content-title">
                                    {isCO
                                        ? lang('小規模チーム向け学習プラットフォーム：')
                                        : lang('团队或项目内部学习平台：')}
                                </div>
                                <div className="content-list">{getList(businessEditionList)}</div>
                            </div>
                        </div>
                    </DistinctionCO>
                </If>
                <If condition={!isShowCommerical}>
                    <div
                        className="version-item-tab"
                        onClick={() => {
                            setShowCommerical(true);
                        }}
                    >
                        <div
                            className="version-tab-title"
                            dangerouslySetInnerHTML={{
                                __html: dupLang('团队版', 'src/plan/@planPricingCommon/components/@pricingVersion'),
                            }}
                        ></div>
                        <PreImg>
                            <img className="open-version" src={openImg} alt="" />
                        </PreImg>
                    </div>
                </If>
            </Fragment>
            <Fragment>
                <If condition={isShowEnterprise}>
                    <div className={platform === 'twww' ? 'version-item' : 'version-item version-m-item last-item'}>
                        <div className="version-item-title">
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: dupLang('企业版', 'src/plan/@planPricingCommon/components/@pricingVersion'),
                                }}
                            ></span>
                            <If condition={platform === 'mobile'}>
                                <div
                                    className="close-wraper"
                                    onClick={() => {
                                        setShowEnterprise(false);
                                    }}
                                >
                                    <PreImg>
                                        <img className="close-version" src={closeImg} alt="" />
                                    </PreImg>
                                </div>
                            </If>
                        </div>
                        <div className="version-item-des">{lang('适用于大型企业或集团')}</div>
                        <div className="version-item-price">
                            <div className="price-des price-des-text">
                                {platform === 'twww' && (
                                    <div className="price-enterprise-text">
                                        <br />
                                    </div>
                                )}
                                <div className="jp-des"></div>
                                <DistinctionCO>
                                    <div className="unit-price-des">{lang('営業担当よりご案内させていただきます')}</div>
                                </DistinctionCO>
                            </div>
                            <EnterpriseBuyButton className="price-button-m" {...props} />
                        </div>
                        <div className="version-item-content">
                            <div
                                className="content-title"
                                dangerouslySetInnerHTML={{
                                    __html: isLang('jp')
                                        ? lang('大規模組織向け<br>学習プラットフォーム：')
                                        : lang('企业级学习平台解决方案：'),
                                }}
                            ></div>
                            <div className="content-list">{getList(enterpriseEditionList)}</div>
                        </div>
                    </div>
                </If>
                <If condition={!isShowEnterprise}>
                    <div
                        className={`version-item-tab ${platform === 'mobile' ? '' : 'last-version-item-tab'}`}
                        onClick={() => {
                            setShowEnterprise(true);
                        }}
                    >
                        <div
                            className="version-tab-title"
                            dangerouslySetInnerHTML={{
                                __html: dupLang('企业版', 'src/plan/@planPricingCommon/components/@pricingVersion'),
                            }}
                        ></div>
                        <PreImg>
                            <img className="open-version" src={openImg} alt="" />
                        </PreImg>
                    </div>
                </If>
            </Fragment>

            <Fragment>
                <If condition={platform === 'mobile'}>
                    <div className="version-item version-m-item last-item">
                        <div className="version-item-title">
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: lang('教育专业版'),
                                }}
                            ></span>
                        </div>
                        <div className="version-item-des">
                            {lang('在职教师或教育工作者可申请加入UMU教育计划，免费升级教育专业版。')}
                        </div>
                        <div className="version-item-price">
                            <div className="price-des price-des-text">
                                {platform === 'twww' && (
                                    <div className="price-enterprise-text">
                                        <br />
                                    </div>
                                )}
                            </div>
                            <div className="price-button price-button-m">
                                <If condition={!isEduProfessional}>
                                    <Button
                                        className="price-edition-btn"
                                        alias="striking"
                                        href="/home/edu"
                                        target="_blank"
                                    >
                                        {commonLang('免费升级')}
                                    </Button>
                                </If>
                                <If condition={isEduProfessional}>
                                    <Fragment>
                                        <Button className="price-edition-btn" alias="striking">
                                            {commonLang('正在使用')}
                                        </Button>
                                    </Fragment>
                                </If>
                            </div>
                        </div>
                        <div className="version-item-content">
                            <div className="content-list">{getList(eduProfessionalEdition)}</div>
                        </div>
                    </div>
                </If>
            </Fragment>
            <Dialog
                show={false}
                hasMask
                width="900"
                className="trial-dialog"
                canClose
                close={() => {
                    // setShowTrialDialog(false);
                }}
            >
                <DialogHeader>
                    <h2 className="header">{lang('团队版试用须知')}</h2>
                </DialogHeader>
                <DialogBody>
                    <p className="content">
                        {lang('申请试用后，您将获得 20 个账户席位，体验UMU团队版的团队学习平台功能。')}
                    </p>
                    <p className="content mt-30">
                        {lang(
                            '团队版试用期为 7 天，试用期间您可以随时提前结束试用。试用结束后，您的账户会自动恢复至当前使用的版本。',
                        )}
                    </p>
                    <p className="content mt-30">
                        {lang('然而，')}
                        <span className="bold">
                            {lang('团队版试用期间，您的账户权限仍然受到限制，不会解锁无限学员特权、视频上传特权。')}
                        </span>
                    </p>
                    <p className="content">
                        {lang('如需立即解锁上述特权，请')}{' '}
                        <Button
                            className="price-edition-text"
                            alias="text"
                            onClick={() => {
                                trackEvent(ACTION_TYPE.CLICK_BUSINESS, DEVICE_FROM_MAP[platform]);
                                onPlan(PLAN_TYPE.COMMERICAL, true);
                            }}
                        >
                            {lang('正式购买团队版')}
                        </Button>
                        {lang('。')}
                    </p>
                    <div className="flex-center mt-20">
                        <Button
                            className={`price-edition-btn now-buy-btn`}
                            alias="striking"
                            onClick={() => {
                                trackEvent(ACTION_TYPE.CLICK_FREE, DEVICE_FROM_MAP[platform]);
                                markStartCommercialTrial();
                                redirectToCommericalTrial(platform, isRegisterUser);
                                // setShowTrialDialog(false);
                                setStatLogDialogs({ page_type: 16, action_type: '2' });
                            }}
                        >
                            {lang('确认申请试用')}
                        </Button>
                    </div>
                </DialogBody>
            </Dialog>
        </Fragment>
    );
};
